/*
 * Project: BookingEngine
 * Module: components/Home.js
 * vim:ft=javascript.jsx:
 */
import React from 'react';
import { connect } from 'react-redux';
import { setFormVisible } from 'bookingform';
import { BOOKING_STEP, setStep, injectGoogleMaps } from '../actions/Booking';

class Home extends React.Component {
  // eslint-disable-next-line react/no-deprecated
  componentWillMount() {
    this.props.dispatch(setStep(BOOKING_STEP.INITIAL));
    this.props.dispatch(injectGoogleMaps());
    this.props.dispatch(setFormVisible(true));
  }

  render() {
    return (
      <React.Fragment></React.Fragment>
    );
  }
}

export default connect()(Home);
